// extracted by mini-css-extract-plugin
export default {"container":"SimpleComponentRender_container__VLBMQ","canvasContainer":"SimpleComponentRender_canvasContainer__8Jrjy"};